import { useMemo } from 'react'

import { useQueryGetAllItemsAvailability } from '@flecto/core/store'
import { type CoreItem } from '@flecto/types'

import { useStoreBasket } from './useStoreBasket'
import { useStoreDates } from './useStoreDates'
import { useStoreDetails } from './useStoreDetails'
import { useStoreItemAvailabilityMerge } from './useStoreItemAvailabilityMerge'

export type UseStoreItemAvailabilityListOptions = {
  items?: CoreItem[]
}

export function useStoreItemAvailabilityList({
  items,
}: UseStoreItemAvailabilityListOptions) {
  const store = useStoreDetails()
  const { startAt, endAt } = useStoreDates()
  const { getBasketItem, items: basketItems } = useStoreBasket()

  const itemsToFilter = useMemo(() => {
    return items?.map((item) => {
      const basketItem = getBasketItem(item)

      return {
        id: Number(item.id),
        quantity: 1,
      }
    })
  }, [items])

  const { data: itemsAvailability, isFetching } =
    useQueryGetAllItemsAvailability({
      storeDomain: store?.domain,
      options: {
        start_at: startAt ?? '',
        end_at: endAt ?? '',
        items: itemsToFilter,
      },
    })

  const itemsWithAvailability = useMemo(
    () =>
      items?.map((item) => {
        const basketItem = getBasketItem(item)
        const itemAvailability = itemsAvailability?.data?.find(
          (ia) => ia.item_id === item.id
        )

        return useStoreItemAvailabilityMerge({
          item,
          itemAvailability,
          quantityToAdd: 1,
          startAt,
          endAt,
        })
      }),
    [items, itemsAvailability, basketItems]
  )

  return {
    data: itemsWithAvailability,
    isLoading: isFetching,
  }
}
